import { render, staticRenderFns } from "./AddSerial.vue?vue&type=template&id=64296f9e"
import script from "./AddSerial.vue?vue&type=script&lang=js"
export * from "./AddSerial.vue?vue&type=script&lang=js"
import style0 from "./AddSerial.vue?vue&type=style&index=0&id=64296f9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports